import React from 'react';
import { usePayHeadsList } from './hooks/usePayHeadsList';
import SharedFilters from '../../../components/SharedFilters';
import AppPagination from '../../../components/AppPagination';
import PayHeadsTable from './components/PayHeadsTable';

export default function PayHeadsListScreen() {
  const { state, actions } = usePayHeadsList();

  const statusTabs = [
    { key: 'Active', label: 'Active' },
    { key: 'Archive', label: 'Archive' },
    { key: 'All', label: 'All' },
  ];

  return (
    <div className="mx-auto flex w-full max-w-[1460px] flex-col gap-6 pb-12">
      {/* Header Banner with Title on Left, Status Toggle Filter on Right */}
      <section className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="font-display text-4xl font-extrabold leading-[0.98] tracking-[-0.02em] text-on-surface">
            Pay Head Master
          </h1>
          <p className="text-xs text-on-surface-variant font-medium mt-1">
            Configure salary components, earning categories, statutory deductions, formula percentages, and slab rules.
          </p>
        </div>

        {/* Actions Cluster: Segmented Status Tabs (No local Add button; use global Top Navbar '+ Create New') */}
        <div className="flex items-center gap-1.5 p-1 rounded-2xl bg-surface-container-high w-fit shadow-xs">
          {statusTabs.map((tab) => {
            const isActive = state.statusFilter === tab.key;
            return (
              <button
                key={tab.key}
                type="button"
                onClick={() => actions.handleStatusTabChange(tab.key)}
                className={`px-5 py-2 rounded-xl text-xs font-bold transition-all cursor-pointer select-none ${
                  isActive
                    ? 'bg-primary text-on-primary shadow-sm'
                    : 'text-on-surface-variant hover:text-on-surface hover:bg-surface-container-highest/60'
                }`}
              >
                {tab.label}
              </button>
            );
          })}
        </div>
      </section>

      {/* Shared Filters Component */}
      <SharedFilters
        searchField={state.searchField}
        searchText={state.searchText}
        setSearchField={actions.setSearchField}
        setSearchText={actions.setSearchText}
        searchFieldOptions={state.searchFieldOptions}
        typeFilter={state.typeFilter}
        setTypeFilter={actions.setTypeFilter}
        typeOptions={state.typeOptions}
        statusFilter={state.statusFilter}
        setStatusFilter={actions.setStatusFilter}
        showStatus={false}
        visibleAccordionFilters={['type']}
        showAccordionToggle={true}
        tools={state.tools}
        onToolSelect={actions.handleToolSelect}
        onSearch={actions.handleSearch}
        onReset={actions.resetFilters}
      />

      {/* Data Table */}
      <section className="space-y-4">
        <PayHeadsTable
          records={state.records}
          isLoading={state.isLoading}
          onDelete={actions.handleDelete}
          onArchive={actions.handleArchive}
          onResetFilters={actions.resetFilters}
        />

        {/* Table Footer with Pagination */}
        <div className="flex flex-col items-center justify-between gap-4 border-t border-outline-variant/15 px-6 py-4 sm:flex-row bg-surface-container-lowest rounded-2xl shadow-xs">
          <p className="text-xs text-on-surface-variant font-medium">
            Showing {state.totalCount === 0 ? 0 : (state.page - 1) * state.pageSize + 1} to{' '}
            {Math.min(state.page * state.pageSize, state.totalCount)} of {state.totalCount} entries
          </p>
          <AppPagination
            page={state.page}
            totalPages={state.totalPages}
            onPageChange={actions.setPage}
            onPrevious={() => actions.setPage((p) => Math.max(p - 1, 1))}
            onNext={() => actions.setPage((p) => Math.min(p + 1, state.totalPages))}
            canPrevious={state.page > 1}
            canNext={state.page < state.totalPages}
          />
        </div>
      </section>
    </div>
  );
}
